import React from 'react';

import './SliderStories.less';

const SliderStories = ({ banner, isMobile, isDesktop }) => {
  return (
  <div className="hero-holder">
    <a key={banner.order_index} className="hero-link" href={banner.button.link}>
      <img
        className="hero-image"
        alt="hero img"
        src={isMobile
          ? banner.images.swiper_mobile
          : banner.images.swiper_desktop}
      />
      <div
        className="hero-text text"
        style={
          (isMobile && banner.order_index >= 2)
          || (isDesktop && banner.order_index >= 3)
          ? { color: '#000' }
          : { color: banner.description.colorText }
        }
      >
        {banner.description.text}
      </div>
    </a>
  </div>
  );
};

export default SliderStories;
